<template>
  <div class="dashboard-statistics" v-resize="handleResize">
    <div class="top-container">
      <div class="top-left-container">
        <div :class="['normal-panel', enlargeHouseStat ? 'enlarge-house-panel' : '']" v-resize="handleResizeChartStat('roomStatChart')">
          <div class="title-bar">
            <span class="panel-title">房源统计{{ enlargeHouseStat ? '' : '（Top10）' }}</span>
            <div class="suffix-box">
              <el-button v-if="!enlargeHouseStat" size="small" type="text" @click.stop="toggleChartEnlargeStat('house')">详细分布<ArrowRight width="16px" height="16px" /></el-button>
              <Close v-else width="20px" height="20px" @click="toggleChartEnlargeStat('house')" />
            </div>
          </div>
          <div class="panel-content chart-content">
            <div id="room-stat-chart" style="width: 100%; height: 100%"></div>
          </div>
        </div>
        <div :class="['normal-panel', enlargeManagerStat ? 'enlarge-manager-panel' : '']" v-resize="handleResizeChartStat('managerStatChart')">
          <div class="title-bar">
            <span class="panel-title">经营者统计{{ enlargeManagerStat ? '' : '（Top10）' }}</span>
            <div class="suffix-box">
              <el-button v-if="!enlargeManagerStat" size="small" type="text" @click.stop="toggleChartEnlargeStat('manager')">详细分布<ArrowRight width="16px" height="16px" /></el-button>
              <Close v-else width="20px" height="20px" @click="toggleChartEnlargeStat('manager')" />
            </div>
          </div>
          <div class="panel-content chart-content">
            <div id="manager-stat-chart" style="width: 100%; height: 100%"></div>
          </div>
        </div>
      </div>

      <div class="top-center-container">
        <div class="top-statistics">
          <div class="stat-pane">
            <img :src="paneIconRoom" alt="" class="pane-icon">
            <div class="pane-desc">
              <span class="pane-label">房源</span>
              <span class="pane-count">{{ roomTotalCount }}</span>
            </div>
          </div>
          <div class="stat-pane purple">
            <img :src="paneIconGroup" alt="" class="pane-icon">
            <div class="pane-desc">
              <span class="pane-label">经营者</span>
              <span class="pane-count">{{ managerTotalCount }}</span>
            </div>
          </div>
          <div class="stat-pane blue">
            <img :src="paneIconPeople" alt="" class="pane-icon">
            <div class="pane-desc">
              <span class="pane-label">在住人员</span>
              <span class="pane-count">{{ stayInTotalCount }}</span>
            </div>
          </div>
        </div>
        <div :class="['center-map', isFullScreen ? 'full-screen-map' : '']">
          <div id="center-map-container"></div>
          <div class="area-cas-selector">
            <el-cascader v-model="curAreaCasList" :options="areaCasList" :props="areaCasProps" placeholder="选择区域将更改本页面数据" clearable @change="handleChangeArea"></el-cascader>
          </div>
          <div :class="['room-selector', isFullScreen ? 'full-screen-width' : '']">
            <el-input v-model="roomSearch" placeholder="请输入房名" suffix-icon="Search" clearable @change="handleRoomSearch" @input="handleRoomSearch"></el-input>
            <div class="full-screen" @click="handleMapFullScreen" :title="isFullScreen ? '缩小' : '全屏'">
              <Back v-if="isFullScreen" width="16px" height="16px" />
              <FullScreen v-else width="16px" height="16px" />
            </div>
          </div>
          <div v-if="this.selectedRoomList.length" :class="['room-res-count', isFullScreen ? 'full-screen-width' : '']">
            <span>共有{{ this.selectedRoomList.length }}个房源</span>
          </div>
          <div v-if="this.selectedRoomList.length" :class="['room-res-box', isFullScreen ? 'full-screen-width' : '']">
            <div class="room-item" v-for="room in selectedRoomList" :key="room.id" @click="focusRoom(room)">
              <img :src="locationDefaultIcon" class="room-default-icon">
              <div class="room-detail">
                <span class="room-name">{{ room.wyfmc }}</span>
                <span class="room-addr">{{ room.wyfdzQhnxxdz }}</span>
              </div>
              <div class="room-img" :style="{ 'background-image': `url(${room.zp})` }"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="top-right-container">
        <div class="normal-panel">
          <div class="title-bar">
            <span class="panel-title">信息审核</span>
          </div>
          <div class="panel-content chart-content">
            <div id="audit-room-chart" style="width: 50%; height: 100%"></div>
            <div id="audit-manager-chart" style="width: 50%; height: 100%"></div>
          </div>
        </div>
        <div class="normal-panel">
          <div class="title-bar">
            <span class="panel-title">智能设备</span>
          </div>
          <div class="panel-content flex-content">
            <div class="equip-box">
              <div class="count-box">
                <div class="count-item">
                  <span class="count-num warn-color">{{ deviceStat.countDoorBinging }}</span>
                  <span>已安装门锁房源</span>
                </div>
                <div class="count-item">
                  <span class="count-num">{{ deviceStat.countDoorNoBinging }}</span>
                  <span>未安装门锁房源</span>
                </div>
              </div>
              <div class="progress-box">
                <el-progress type="circle" :percentage="deviceStat.lockBindPercent" :width="100" color="#fca851"></el-progress>
                <span class="progress-tips">门锁安装比例</span>
              </div>
            </div>
            <div class="equip-box">
              <div class="count-box">
                <div class="count-item">
                  <span class="count-num warn-color">{{ deviceStat.countBellBinging }}</span>
                  <span>已安装门铃房源</span>
                </div>
                <div class="count-item">
                  <span class="count-num">{{ deviceStat.countBellNoBinging }}</span>
                  <span>未安装门铃房源</span>
                </div>
              </div>
              <div class="progress-box">
                <el-progress type="circle" :percentage="deviceStat.bellBindPercent" :width="100" color="#fca851"></el-progress>
                <span class="progress-tips">门铃安装比例</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-container">
      <div class="normal-panel normal-panel-person" v-show="trendActive==1">
        <div class="title-bar">
          <div class="title-box title-box-active" >
            <div class="panel-title">入住人员趋势</div>
            <div class="sub-title">统计新入住人员数量</div>
          </div>
          <div class="title-box" @click="setTrendActive(2)">
            <div class="panel-title">在住人员趋势</div>
            <div class="sub-title">统计所有在住人员数量</div>
          </div>
          <div class="suffix-box">
            <el-select class="box-search-item" v-model="checkInStatType" size="small" placeholder="请选择" @change="getCheckInTrendStat">
              <el-option v-for="item in statDateTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="panel-content chart-content">
          <div class="realtime-data" v-if="checkInTrend.show">
            <span class="now-data">
              {{ checkInTrend.value }}
              <i class="el-icon-caret-top danger-color" v-if="checkInTrend.trend === 1"></i>
              <i class="el-icon-caret-bottom success-color" v-if="checkInTrend.trend === -1"></i>
            </span>
            <span class="compare-data">
              <span :class="getTrendColorClass('percent-data', checkInTrend.trend)">{{ checkInTrend.trendPercent }}</span> 环比
            </span>
          </div>
          <div id="check-in-trend-chart" class="trend-chart-container"></div>
        </div>
      </div>
      <div class="normal-panel normal-panel-person" v-show="trendActive==2">
        <div class="title-bar">
          <div class="title-box " @click="setTrendActive(1)">
            <div class="panel-title">入住人员趋势</div>
            <div class="sub-title">统计新入住人员数量</div>
          </div>
          <div class="title-box title-box-active" >
            <div class="panel-title">在住人员趋势</div>
            <div class="sub-title">统计所有在住人员数量</div>
          </div>
          <div class="suffix-box">
            <el-select class="box-search-item" v-model="stayInStatType" size="small" placeholder="请选择" @change="getStayInTrendStat">
              <el-option v-for="item in statDateTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="panel-content chart-content">
          <div class="realtime-data" v-if="stayInTrend.show">
            <span class="now-data">
              {{ stayInTrend.value }}
              <i class="el-icon-caret-top danger-color" v-if="stayInTrend.trend === 1"></i>
              <i class="el-icon-caret-bottom success-color" v-if="stayInTrend.trend === -1"></i>
            </span>
            <span class="compare-data">
              <span :class="getTrendColorClass('percent-data', stayInTrend.trend)">{{ stayInTrend.trendPercent }}</span> 环比
            </span>
          </div>
          <div id="stay-in-trend-chart" class="trend-chart-container"></div>
        </div>
      </div>
      <div class="normal-panel">
        <div class="title-bar">
          <span class="panel-title">异常告警</span>
          <div class="suffix-box">
            <el-select class="box-search-item" v-model="alarmStatType" size="small" placeholder="请选择" @change="getAlarmStat">
              <el-option v-for="item in alarmStatTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="panel-content chart-content">
          <div class="realtime-data" v-if="alarmTrend.show">
            <span class="now-data danger-color">
              {{ alarmTrend.value }}
              <i class="el-icon-caret-top danger-color" v-if="alarmTrend.trend === 1"></i>
              <i class="el-icon-caret-bottom success-color" v-if="alarmTrend.trend === -1"></i>
            </span>
            <span class="compare-data">
              <span :class="getTrendColorClass('percent-data', alarmTrend.trend)">{{ alarmTrend.trendPercent }}</span> 环比
            </span>
          </div>
          <div id="alarm-chart" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="normal-panel">
        <div class="title-bar">
          <span class="panel-title">防疫告警</span>
        </div>
        <div class="panel-content chart-content">
          <el-table
            class="sanitary-alarm-table"
            :data="sanitaryAlarmData"
            style="width: 100%"
            height="250"
          >
            <el-table-column
              fixed
              prop="alarm"
              label="告警信息"
              show-overflow-tooltip
              class="sanitary-alram-col1"
              >
              <template #header>
                <div class="sanitary-alram-header">告警信息</div>
              </template>
              <template #default="scope">
                <div class="sanitary-alram-row">
                  <div class="sanitary-alram-info">
                    <div :class="'info-level-'+(scope.row.riskLevel=='高' ? 'high':'mid')">{{ scope.row.riskLevel }}</div>
                    <div class="info-name">{{ scope.row.name }}</div>
                    <div class="info-phone">{{ scope.row.phone }}</div>
                  </div>
                  <div class="sanitary-alram-cnt"><span class="info-label">证件号码：</span><span >{{ scope.row.credentialsNum }}</span></div>
                  <div class="sanitary-alram-cnt"><span class="info-label">告警区域：</span><span >{{ scope.row.riskDistricts }}</span></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="room"
              label="告警房源"
              show-overflow-tooltip
              >
              <template #default="scope">
                <div ><span class="sanitary-alram-room">{{ scope.row.house }}</span></div>
                <div class="sanitary-alram-cnt">房源地址：{{ scope.row.houseAddress }}</div>
                <div class="sanitary-alram-cnt">告警时间：{{ scope.row.alarmTime }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './lib/MarkerClusterer' // 为了解决MarkerClusterer关于Label消失的问题而引入
import { mapActions, mapState } from 'vuex'

import paneIconRoom from '@/assets/img/dashboard/statistics/center-top-statistics-icon-room.png'
import paneIconGroup from '@/assets/img/dashboard/statistics/center-top-statistics-icon-group.png'
import paneIconPeople from '@/assets/img/dashboard/statistics/center-top-statistics-icon-people.png'
import locationActiveIcon from '@/assets/img/dashboard/statistics/location-icon-active.png'
import locationDefaultIcon from '@/assets/img/dashboard/statistics/location-icon-default.png'

import mixin from './index'
import chartMapMixin from './chartAndMap'

export default {
  mixins: [ mixin, chartMapMixin ],
  data() {
    return {
      paneIconRoom,
      paneIconGroup,
      paneIconPeople,
      locationActiveIcon,
      locationDefaultIcon,

      enlargeHouseStat: false, // 是否放大房源统计
      enlargeManagerStat: false, // 是否放大经营者统计

      roomTotalCount: '--', // 顶部房源总数统计
      stayInTotalCount: '--', // 顶部在住人员总数统计
      managerTotalCount: '--', // 顶部经营者总数统计

      auditStat: {}, // 审核统计
      deviceStat: {}, // 设备统计

      alarmStatType: 1, // 告警数据统计类型
      stayInStatType: 1, // 在住数据统计类型
      checkInStatType: 1, // 入住数据统计类型

      alarmTrend: {},
      alarmStatData: [],
      stayInTrend: {},
      stayInStatData: [],
      checkInTrend: {},
      checkInStatData: [],

      statDateTypeList: [
        { label: '近7日', value: 1, type: 'week' },
        { label: '近1月', value: 2, type: 'month' },
        { label: '近1年', value: 3, type: 'year' },
      ],
      alarmStatTypeList: [
        { label: '昨日', value: 1, type: 'day' },
        { label: '近7日', value: 2, type: 'week' },
        { label: '近1月', value: 3, type: 'month' },
        { label: '近1年', value: 4, type: 'year' },
      ],

      curAreaCasList: [],
      areaCasList: [],
      areaCasProps: {
        lazy: true,
        lazyLoad: this.loadAreaCasNode,
        checkStrictly: true,
      },

      roomList: [],
      roomSearch: '',
      isFullScreen: false,
      selectedRoomList: [], // 当前展示房源列表

      /**
       * dwbgdzSfbm: 省份编码
       * dwbgdzSbm: 市编码
       * dwbgdzQbm: 区编码
       * streetOffice: 街道编码
       * neighborCmm: 居委会编码
       */
      areaCodeKeysPinyin: ['dwbgdzSfbm', 'dwbgdzSbm', 'dwbgdzQbm', 'streetOffice', 'neighborCmm'],
      areaCodeKeys: ['province', 'city', 'region', 'streetOffice', 'neighborCmm'],
      curAreaInfoPinyin: {},
      curAreaInfo: {},
      sanitaryAlarmData: []//防疫告警
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.common.user,
    }),
    // 获取趋势颜色
    getTrendColorClass() {
      let callback = function(classes, trend) {
        let colorClass = trend === 1 ? 'danger-color' : trend === -1 ? 'success-color' : ''
        return `${classes} ${colorClass}`
      }
      return callback
    }
  },
  created() {
    this.initAreaInfo()
    this.initAllStatData()
  },
  beforeRouteLeave (to, from, next) {
    this.chartPropNameList.forEach(item => {
      clearInterval(this[item + 'Timer'])
    })
    next()
  },
  methods: {
    ...mapActions([ 'fetchData' ]),
    // 初始化全部数据
    initAllStatData() {
      this.getAlarmStat()
      this.getHouseStat()
      this.getManagerStat()
      this.getAuditStat()
      this.getDeviceStat()
      this.getMapRoomList()
      this.getStayInTrendStat()
      this.getCheckInTrendStat()
      this.getSanitaryAlarmData()
    },
    // 获取房源统计数据
    getHouseStat() {
      let url = 'SAAS.DASHBOARD_HOUSE'
      let params = {
        params: JSON.stringify(this.curAreaInfo)
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        this.roomTotalCount = res.count || 0

        let data = res.data || []
        data.forEach(item => {
          let total = item.countLive + item.countNoLive
          item.countTotal = total
          if (total === 0) {
            item.noLivePercent = 0
          } else {
            item.noLivePercent = Number(((item.countNoLive / total) * 100).toFixed(2))
          }
        })

        this.houseStat = data
        this.initRoomStatChart()
      })
    },
    // 获取经营者统计数据
    getManagerStat() {
      let url = 'SAAS.DASHBOARD_MANAGER'
      let params = {
        params: JSON.stringify(this.curAreaInfo)
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        this.managerTotalCount = res.count || 0
        this.managerStat = res.data || []
        this.initManagerStatChart()
      })
    },
    // 获取审核统计数据
    getAuditStat() {
      let url = 'SAAS.DASHBOARD_AUDIT'
      let params = {
        params: JSON.stringify(this.curAreaInfo)
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        this.auditStat = res || { dataHouseAudit: {}, dataOperatorAudit: {} }

        if (this.auditRoomChart && this.auditManagerChart) {
          this.initAuditChart()
        } else {
          this.delayInitChart(this.initAuditChart)
        }
      })
    },
    // 获取设备数据统计
    getDeviceStat() {
      let url = 'SAAS.DASHBOARD_DEVICE'
      let params = {
        params: JSON.stringify(this.curAreaInfo)
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        let data = res && res.data
        if (data) {
          // 为 0 的兼容操作
          let bellBind = data.countBellBinging
          let bellTotal = bellBind + data.countBellNoBinging
          if (bellTotal) {
            data.bellBindPercent = Math.round(bellBind / bellTotal * 100)
          } else {
            data.bellBindPercent = 0
          }

          let lockBind = data.countDoorBinging
          let lockTotal = lockBind + data.countDoorNoBinging
          if (lockTotal) {
            data.lockBindPercent = Math.round(lockBind / lockTotal * 100)
          } else {
            data.lockBindPercent = 0
          }
          this.deviceStat = data
        } else {
          this.$message.error('设备统计获取失败！')
        }
      })
    },
    // 仅仅只是查询房源列表
    handleRoomSearch() {
      if (!this.roomSearch) {
        this.selectedRoomList = []
        return
      }
      this.getMapRoomList({ isSearch: true })
    },
    // 获取房源列表
    getMapRoomList(opts = {}) {
      let url = 'SAAS.ROOM_LIST'

      let param = {
        isExamine: '1',
        requestType:1,
        ...this.curAreaInfoPinyin
      }
      if (opts.isSearch) {
        param.wyfmc = this.roomSearch
      }
      let params = {
        params: JSON.stringify(param),
        start: 0,
        size: 9999999,
        toExcel: false
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        let data = res.data || []

        // 经纬度其中一个为0为空时，该点将无意义，重定位到默认经纬度：(0, 0)
        data.forEach(item => {
          item.bddtjd = item.bddtjd || 0
          item.bddtjd = (Math.round(item.bddtjd * 10000)/10000).toFixed(4)
          item.bddtwd = item.bddtwd || 0
          item.bddtwd = (Math.round(item.bddtwd * 10000)/10000).toFixed(4)
        })

        if (opts.isSearch) { // 只是查询，不需要后续的地图渲染操作
          if (data.length === 0) this.$message.warning('没有查询到房源！')

          this.selectedRoomList = data
          return
        }

        this.roomList = data
        let timer = setInterval(() => {
          if (this.centerMap) {
            this.centerMap.clearOverlays && this.centerMap.clearOverlays()
            this.curMarkerClusterer && this.curMarkerClusterer.clearMarkers()

            this.renderRoomToMap()
            clearInterval(timer)
            timer = null
          }
        }, 50)
      })
    },
    // 获取入住趋势数据
    getCheckInTrendStat() {
      let url = 'SAAS.DASHBOARD_CHECK_IN'
      let param = {
        ...this.curAreaInfo,
        type: this.checkInStatType
      }
      let params = {
        params: JSON.stringify(param)
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        let data = res && res.data
        data = data || {}
        this.checkInStatData = this.buildListDate(data, this.statDateTypeList[param.type - 1].type)

        if (this.checkInTrendChart) {
          this.initCheckInTrendChart()
        } else {
          this.delayInitChart(this.initCheckInTrendChart)
        }
      })
    },
    // 获取在住趋势数据
    getStayInTrendStat() {
      let url = 'SAAS.DASHBOARD_STAY_IN'
      let param = {
        ...this.curAreaInfo,
        type: this.stayInStatType
      }
      let params = {
        params: JSON.stringify(param)
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        this.stayInTotalCount = res.countToday || 0

        let data = res && res.data
        data = data || {}
        this.stayInStatData = this.buildListDate(data, this.statDateTypeList[param.type - 1].type)

        if (this.stayInTrendChart) {
          this.initStayInTrendChart()
        } else {
          this.delayInitChart(this.initStayInTrendChart)
        }
      })
    },
    // 获取告警统计数据
    getAlarmStat() {
      let url = 'SAAS.DASHBOARD_ALARM'
      let param = {
        ...this.curAreaInfo,
        type: this.alarmStatType
      }
      let params = {
        params: JSON.stringify(param)
      }

      this.fetchData({ url, method: 'get', params }).then(res => {
        let data = res && res.data
        data = data || {}
        this.alarmStatData = this.buildListDate(data, this.alarmStatTypeList[param.type - 1].type)

        if (this.alarmChart) {
          this.initAlarmChart()
        } else {
          this.delayInitChart(this.initAlarmChart)
        }
      })
    },
    getSanitaryAlarmData(){
      this.fetchData({ url:'SAASDASHBOARD_SANITARY_ALARM', method: 'get', params:{} }).then(res => {
        this.sanitaryAlarmData = res.data || []
      })
    },
    // 等待页面渲染完毕后构建chart
    delayInitChart(cb) {
      this.$nextTick(() => {
        setTimeout(() => {
          cb && cb()
        }, 50)
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>
